import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useDetalhamento = ({ sqAcaoFiscal, sqItemOcorrencia, reload }) => {
  const [rows, setRows] = useState([]);
  const [totalRows] = useState(0);
  const [pageSize] = useState(50);
  const [pageNumber, setPageNumber] = useState(1);
  const [dataWithTotal, setDataWithTotal] = useState([]);

  const { request: requestConsulta, data: dataConsulta, errors: errorConsulta, isLoading } = useApiClient();

  const handlePageChange = useCallback(
    (newPageNumber) => {
      setPageNumber(newPageNumber);
    },
    [setPageNumber],
  );

  useEffect(() => {
    const params = { sqAcaoFiscal, sqItemOcorrencia, pageSize, pageNumber };
    requestConsulta(apiRoutes.fiscalizacao.ocorrencia.listaDemonstrativoOcorrencia, params);
  }, [requestConsulta, sqAcaoFiscal, sqItemOcorrencia, pageSize, pageNumber, reload]);

  const getTotalRow = (data) => {
    if (!data || data.length === 0) return null;

    const tipoDetalhamento = data[0]?.tipoDetalhamento;

    const tiposTxChave = [ "BT", "BU", "BV", "BW", "BX", "BD", "B2", "B3", "B4"];
    const tiposBYBZ = ["BY","BZ"];
    const tiposTxReferencia = ["Q", "Q1", "Q2", "Q3", "D", "D1", "D2"];
    const tiposDsItem = ["J1", "R", "R2"];
    const tiposNuItem = ["AI", "AM", "M", "P"];

    // Define qual campo deve exibir "Total" dependendo do tipoDetalhamento
    const identificadorTotal = {
      nuItem: null,
      txReferencia: null,
      dsItem: null,
      txChave: null,
      numPedido: null
    };

    if (tiposNuItem.includes(tipoDetalhamento)) {
      identificadorTotal.nuItem = "Total";
    } else if (tiposTxReferencia.includes(tipoDetalhamento)) {
      identificadorTotal.txReferencia = "Total";
    } else if (tiposDsItem.includes(tipoDetalhamento)) {
      identificadorTotal.dsItem = "Total";
    } else if (tiposTxChave.includes(tipoDetalhamento)) {
      // identificadorTotal.txChave = "Total";
      identificadorTotal.nuNotaSerie = "Total";
    } else if (tiposBYBZ.includes(tipoDetalhamento)){
      identificadorTotal.numPedido = "Total";
    }

    const totalRow = {
      ...identificadorTotal,
      vlDeclarado: data.reduce((acc, row) => acc + (row.vlDeclarado || 0), 0),
      vlApurado: data.reduce((acc, row) => acc + (row.vlApurado || 0), 0),
      vlProduto: data.reduce((acc, row) => acc + (row.vlProduto || 0), 0),
      vlBaseCalculo: data.reduce((acc, row) => acc + (row.vlBaseCalculo || 0), 0),
      vlIcmsRecolhido: data.reduce((acc, row) => acc + (row.vlIcmsRecolhido || 0), 0),
      vlIcmsCalculado: data.reduce((acc, row) => acc + (row.vlIcmsCalculado || 0), 0),
      valorTotalNota: data.reduce((acc, row) => acc + (row.valorTotalNota || 0), 0),
      vlArrolamento: data.reduce((acc, row) => acc + (row.vlArrolamento || 0), 0),
      vlCredito: data.reduce((acc, row) => acc + (row.vlCredito || 0), 0),
      vlIcms: data.reduce((acc, row) => acc + (row.vlIcms || 0), 0),
      vlMultaOcorrenciaAtual: data.reduce((acc, row) => acc + (row.vlMultaOcorrenciaAtual || 0), 0),
      valorTotal: data.reduce((acc, row) => acc + (row.vlIcms + row.vlMultaOcorrenciaAtual || 0), 0),
      vlNotaFiscal: data.reduce((acc, row) => acc + (row.vlNotaFiscal || 0), 0),
      isTotalRow: true, // Flag para identificação
    };

    return totalRow;
  };

  useEffect(() => {
    if (dataConsulta && dataConsulta.result) {
      setRows([...dataConsulta.result]);
    }
  }, [dataConsulta]);

  useEffect(() => {
      const totalRow = getTotalRow(rows);
      const rowsWithTotal = totalRow ? [...rows, totalRow] : [...rows];
      setDataWithTotal(rowsWithTotal);
  }, [rows, reload]);

  useEffect(() => {
    if (errorConsulta) {
      toast.error(errorConsulta.message);
    }
  }, [errorConsulta]);

  return { rows, setRows, totalRows, dataWithTotal, isLoading, handlePageChange };
};

export default useDetalhamento;
